import { Component, Mixins, Prop } from "vue-property-decorator";
import LoadingMixin from "../../../mixins/LoadingMixin";
import ProductMixin from "../../../mixins/ProductMixin";
import ShoppingCartMixin from "../../../mixins/ShoppingCartMixin";
import { SectionItem } from "@/views/products-and-services/components/SectionInterfaces";

@Component
export default class SectionSummary extends Mixins(LoadingMixin, ProductMixin, ShoppingCartMixin) {
    @Prop({ type: Number, required: true })
    private step!: number;
    @Prop({ type: String, required: true })
    private title!: string;
    @Prop({ type: Array, required: true })
    private items!: SectionItem[];
    @Prop({ type: Boolean, required: false, default: true })
    private showAmount!: boolean;

    get massagedItems(): SectionItem[] {
        return this.items.length > 0 ? this.items : [{ id: '', name: 'None', amount: '' }];
    }

    editClicked() {
        this.$emit('edit-clicked');
    }

    calculateLoopId(prefix: string, item: SectionItem): string {
        return `${prefix}-${item.id}-${item.catId}`;
    }
}
